var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("h2", [_vm._v("Instagram Sharing")]),
      _vm._v(" "),
      _c("gallery-panel", { attrs: { medias: _vm.$model.medias } }),
      _vm._v(" "),
      _c("caption-panel", { attrs: { caption: _vm.$model.caption } }),
      _vm._v(" "),
      _c("instructions-panel"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }